// extracted by mini-css-extract-plugin
export default {"wrapper":"AddHardwareLayout_wrapper__H2oAT"};